// 发布面试题相关请求
import request from '@/utils/request'

// 查询首页需要的三个模块中的数据
export const findModelDate =()=>{
    return request.get(
        '/home/findModelDate'
    )
};


